import { useEffect, useState } from 'react';
import {
  IAllowedIPRange,
  IAllowedIPRangeUIModel,
} from './IPRestrictionInterface';
import {
  StyledTextArea,
} from './StyledComponents';
import { AllowedIpRangeComponent } from './AllowedIpRangeComponent';
import { useTranslation } from 'react-i18next';
import { AllowedIPInputWithHelperText } from './AllowedIPInputWithHelperText';

export const GlobalTemplate = ({
  template,
}: any): JSX.Element => {

  const { t } = useTranslation();
  const [allowedIPRangeModel, setAllowedIPRangeModel] = useState<IAllowedIPRangeUIModel[]>([]);
  const [ipAddress, setIpAddress] = useState<string>('');

  useEffect(() => {
    setIpAddress(template.allowedIps?.join(',') || '');
    const allowedIpRange = template.allowedIpRange?.map(
      (ipRange: IAllowedIPRange, index: number) => {
        return {
          id: index + 1,
          begin: ipRange.begin,
          end: ipRange.end,
        } as IAllowedIPRangeUIModel;
      }
    ) || [];
    setAllowedIPRangeModel(allowedIpRange);
  }, [template]);

  return (
    <>
      <div style={{ marginTop: '10px' }}>
        <div
          style={{
            fontFamily: 'Roboto,sans-serif',
            fontWeight: 400,
            fontSize: '14px',
            marginLeft: '8px',
            marginTop: '5px',
            marginBottom: '5px',
          }}
        >
          {t('dealer-admin.ip-access.label.allowedIPAddressTemplate')}
        </div>
        <AllowedIPInputWithHelperText helperLabel={t('dealer-admin.ip-access.label.publicIpInfo')}>
        <StyledTextArea
          dataTestId={`ip-address-input`}
          id={`ip-address-input`}
          inputDivider="left"
          label={t('dealer-admin.ip-access.label.ipAddress')}
          name={'ipaddress'}
          placeholder={t('dealer-admin.ip-access.label.ipAddressPlaceHolder')}
          value={ipAddress || ''}
          onChange={()=>{}}
          isDisabled
        />
        </AllowedIPInputWithHelperText>
      </div>
      <div>
        { 
          allowedIPRangeModel && 
          allowedIPRangeModel.length >0 &&
              <AllowedIpRangeComponent
                allowedIPRange={allowedIPRangeModel}
                setAllowedIPRangeModel={setAllowedIPRangeModel}
                label={t('dealer-admin.ip-access.label.allowedIPRangeTemplate')}
                isDisabled
              />
        }
      </div>
    </>
  );
};
